"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Grid_1 = __importDefault(require("../../layout/Grid/Grid"));
const IconSel_1 = __importDefault(require("./IconSel"));
function IconTextSel(props) {
    const { onChange, sel, className, placeholder, disabled } = props;
    const [cur, setCur] = (0, react_1.useState)(sel || {
        icon: null,
        text: '',
    });
    return (react_1.default.createElement(Grid_1.default, { className: className, flex: true, flexR: true, gap: 8 },
        react_1.default.createElement(Grid_1.default, null,
            react_1.default.createElement(IconSel_1.default, { disabled: disabled, sel: cur.icon || undefined, onChange: (i) => {
                    setCur((s) => ({ text: s.text, icon: i }));
                    onChange({ text: cur.text, icon: i });
                } })),
        react_1.default.createElement(Grid_1.default, { grow: 1 },
            react_1.default.createElement("input", { value: cur.text, onChange: (i) => {
                    setCur((s) => ({ text: i.target.value, icon: s.icon }));
                    onChange({ text: i.target.value, icon: cur.icon });
                }, placeholder: placeholder, disabled: disabled }))));
}
exports.default = IconTextSel;
IconTextSel.defaultProps = {
    className: undefined,
    disabled: false,
    sel: undefined,
    placeholder: undefined,
};
